<template>
  <!-- 操作日志 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="12">
            <a-form-item label="请求ID">
              <a-input v-model="query.requestId" placeholder="请输入请求ID" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="名称">
              <a-input v-model="query.name" placeholder="请输入名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="类型">
              <a-select placeholder="请选择" default-value="" v-model="query.type">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">接口访问</a-select-option>
                <a-select-option value="2">用户登录</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="状态">
              <a-select placeholder="请选择" default-value="" v-model="query.status">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">成功</a-select-option>
                <a-select-option value="2">失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <!-- <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()">删除</a-button> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      size='middle'
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <a-tag :color="text === 1 ? 'rgb(50, 205, 50)' : 'rgb(255, 99, 71)'" slot="status" slot-scope="text">{{ text | statusFilter }}</a-tag>
      <a-tag :color="text === 1 ? 'rgb(50, 205, 50)' : '#fdac00'" slot="type" slot-scope="text">{{ text | typeFilter }}</a-tag>
      <span slot="action" slot-scope="text, record">
        <a @click="detailInfo(record)">详情</a>
      </span>
    </a-table>
    <a-modal
      title="详情"
      style="top: 20px"
      :width="800"
      v-model="detailVisible"
      @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="log-form" :form="detailForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用名称">
          <a-input disabled v-model="detailForm.application" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="请求名称">
          <a-input disabled v-model="detailForm.name" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="请求ID">
          <a-input disabled v-model="detailForm.requestId" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="请求状态">
          <a-tag :color="detailForm.status === 1 ? 'green' : 'orange'">
            {{ detailForm.status === 1 ? '成功' : '失败' }}
          </a-tag>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="请求时间">
          {{ detailForm.createTime }}
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="请求参数">
          <a-textarea disabled v-model="detailForm.requestParams" :auto-size="{ minRows: 5, maxRows: 10 }" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户代理">
          <a-textarea disabled v-model="detailForm.userAgent" :auto-size="{ minRows: 5, maxRows: 10 }" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="消息结果">
          <a-textarea disabled v-model="detailForm.errorMessage" :auto-size="{ minRows: 5, maxRows: 10 }" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'

const STATUS = {
  1: '成功',
  2: '失败'
}
const TYPE = {
  1: '接口访问',
  2: '用户登录'
}

const columns = [
  {
    title: '应用名',
    dataIndex: 'application'
  },
  {
    title: '类型',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '名称',
    dataIndex: 'name'
  },
  {
    title: '水司ID',
    dataIndex: 'tenantId'
  },
  {
    title: '操作人',
    dataIndex: 'username'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: 'IP',
    dataIndex: 'ipAddress'
  },
  {
    title: '请求ID',
    dataIndex: 'requestId'
  },
  {
    title: '请求路径',
    dataIndex: 'requestUri'
  },
  {
    title: '请求方法',
    dataIndex: 'requestMethod'
  },
  {
    title: '耗时(ms)',
    dataIndex: 'requestTime'
  },
  {
    title: '请求时间',
    dataIndex: 'createTime'
  }, {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'LogList',
  data () {
    return {
      queryUrl: 'manager/logs/page',
      query: {
        requestId: '',
        status: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      detailVisible: false, // 详情窗口是否可见
      detailForm: {}
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    typeFilter (key) {
      return TYPE[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () {},
  methods: {
    detailInfo (record) {
      this.detailForm = { ...record }
      this.detailVisible = true
    },
    handleOk () {
      this.detailVisible = false
    },
    handleCancel () {
      this.detailVisible = false
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
